import submitReporting from "./submit";

declare var pm: PmInterface;

export function setupReportingPopup() {
	const getClosest = pm.utils.dom.getClosest;
	const findHtmlEl = pm.utils.dom.findHtmlEl;
	const findHtmlEls = pm.utils.dom.findHtmlEls;
	const notice = pm.utils.notice;

	pm.event.on("pm_popup_will_open", (opts) => {
		const popup = opts.popup;
		const trigger = opts.triggerButton;
		const form = findHtmlEl(popup, ".reporting-form");

		if (!form || !trigger) return;

		const reportedObjectType = trigger.dataset.reportedObjectType;

		let triggerOrigin = "";

		if (trigger.hasAttribute("data-trigger-origin")) {
			triggerOrigin = trigger.dataset.triggerOrigin
				? trigger.dataset.triggerOrigin
				: "";
		}

		form.dataset.reportedObjectType = reportedObjectType;

		if (trigger.hasAttribute("data-reported-object-id")) {
			form.dataset.reportedObjectId = trigger.dataset.reportedObjectId;
		}

		form.dataset.triggerOrigin = "";

		if (reportedObjectType === "photo") {
			if (triggerOrigin === "context-menu") {
				const contextMenu = getClosest(trigger, ".context-menu", 15);
				if (!contextMenu) return;

				form.dataset.reportedObjectId = contextMenu.dataset.photoId;
				form.dataset.triggerOrigin = "context-menu";
			} else if (triggerOrigin === "photo-popup") {
				form.dataset.triggerOrigin = "photo-popup";
			}
		} else if (reportedObjectType === "comment") {
			if (triggerOrigin === "photo-popup") {
				form.dataset.triggerOrigin = "photo-popup";
			}
		}

		if (triggerOrigin === "photo-popup") {
			const popup = getClosest(trigger, ".photo-popup", 20);

			if (popup) {
				if (reportedObjectType === "comment") {
					form.dataset.pmNonce = popup.dataset.reportCommentNonce;
				} else if (reportedObjectType === "photo") {
					form.dataset.pmNonce = popup.dataset.reportPhotoNonce;
				}
			}
		} else {
			form.dataset.pmNonce = trigger.dataset.reportingNonce;
		}

		const reasonSelectboxes = findHtmlEls(form, ".reporting-reason");
		if (!reasonSelectboxes.length) return;

		reasonSelectboxes.forEach((selectbox) => {
			if (!(selectbox instanceof HTMLSelectElement)) return;
			if (selectbox.name === reportedObjectType + "_reporting_reason") {
				selectbox.classList.remove("is-hidden");
			} else {
				selectbox.classList.add("is-hidden");
			}

			selectbox.value = "";
		});

		const popupTitle = findHtmlEl(popup, ".popup-title");
		if (popupTitle) {
			popupTitle.textContent = "Report " + reportedObjectType;
		}

		const submitButton = findHtmlEl(popup, ".submit-button");
		if (submitButton) {
			submitButton.textContent = "Report this " + reportedObjectType;
		}

		const noticeEl = findHtmlEl(form, ".submission-notice");
		if (noticeEl) notice.hide(noticeEl);

		const objectTypeTags = findHtmlEls(form, ".object-type-tag");

		if (objectTypeTags.length) {
			objectTypeTags.forEach((tag) => {
				tag.textContent = reportedObjectType ? reportedObjectType : "";
			});
		}
	});
}

export function setupReportingSubmission() {
	const form = pm.utils.dom.findHtmlEl(".reporting-form");
	if (!form) return;

	form.addEventListener("submit", function (e) {
		e.preventDefault();
		submitReporting(form);
	});
}
